import React from "react"
import { Building2, X, Plus } from "lucide-react"
import { motion, AnimatePresence } from "framer-motion"
import { cn } from "../../../../../lib"

const SearchSuggestionsRow = ({ airport, selectAirport, isOvercrowded }) => {
  return (
    <button
      className={cn(
        "w-full flex items-center gap-1 justify-between p-1 hover:bg-gray-50 rounded-xl transition ml-1 relative disabled:cursor-not-allowed disabled:after:absolute disabled:after:inset-0 disabled:after:flex disabled:after:items-center disabled:after:justify-center disabled:after:text-xl disabled:opacity-60"
      )}
      onClick={() => selectAirport(airport.id)}
      disabled={isOvercrowded && !airport?.is_selected}
    >
      <div className="flex items-center gap-3 flex-1 min-w-0">
        <Building2 className="w-4 h-4 text-text-secondary flex-shrink-0" />
        <div className="text-left flex-1 min-w-0">
          <div className="font-medium text-text-main flex items-center gap-1">
            <span className="text-[13px] flex-shrink-0">{airport.city}</span>
            <span className="text-text-secondary font-normal text-[11px] flex items-center min-w-0">
              (<span className="truncate capitalize max-w-[180px]">{airport.name}</span>)
            </span>
          </div>
          {airport?.distance && (
            <div className="text-xs text-text-secondary">{airport.distance}</div>
          )}
        </div>
      </div>

      <div className="flex items-center gap-2 flex-shrink-0">
        <motion.span
          className={cn("px-1 py-1 w-9 rounded text-xs font-medium text-bg-muted bg-bg-muted/20")}
          animate={{}}
          transition={{ duration: 0.3 }}
        >
          {airport.iata}
        </motion.span>

        <AnimatePresence mode="wait">
          {airport.is_selected ? (
            <motion.div
              key="selected"
              className="w-6 h-6 rounded flex items-center justify-center bg-transparent border-[0.5px] border-black"
              initial={{ scale: 0 }}
              animate={{ scale: 1.2 }}
              exit={{ scale: 0 }}
              transition={{ type: "spring", stiffness: 300, damping: 20 }}
            >
              <X className="w-3 h-3 text-black" />
            </motion.div>
          ) : (
            <motion.div
              key="unselected"
              className="w-6 h-6 rounded flex items-center justify-center bg-second-success"
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0 }}
              transition={{ type: "spring", stiffness: 300, damping: 20 }}
            >
              <Plus className="w-4 h-4 text-white" />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </button>
  )
}

export default SearchSuggestionsRow
